<template>
  <div v-if="Number(this.$local.get('client'))">
    <yd-tabbar :fixed="fixed" class="sky-tabbar">
        <yd-tabbar-item title="拍卖" link="/" :active="$route.name =='home'">
            <i slot="icon" class="iconfont icon-Slicex2"></i>
        </yd-tabbar-item>
        <yd-tabbar-item title="商城" link="/mall" :active="$route.name =='mall'">
            <i slot="icon" class="iconfont icon-Slicex3"></i>
        </yd-tabbar-item>
         <yd-tabbar-item title="社区" link="/community" :active="$route.name =='community'">
            <i slot="icon" class="iconfont icon-Slicex1"></i>
        </yd-tabbar-item>
        <!-- <yd-tabbar-item title="我的" link="/user" :active="$route.name =='user'">
            <i slot="icon" class="iconfont icon-Slicex7"></i>
        </yd-tabbar-item> -->
    </yd-tabbar>
    <div style="height: .8rem;"></div>
  </div>
</template>

<script>
// import headNav from '@/components/common/head'
export default {
  props:['fixed'],
  name: 'Tabbar',
  components: {
        // headNav
    },
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {

  },
  mounted() {

  },
  watch: {
    $route() {

    }
  }
}
</script>

<style scoped>
 .iconfont {
  font-size: .4rem;
 }
 .yd-tabbar-active, .yd-tabbar-active .iconfont {
    color: #DA7649 !important;
}

</style>
<style>
  .sky-tabbar footer {
    max-width: 750px;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Tabbar.vue